/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import customUtil from '../../../objects/customUtil.js';

class customOptionsInlineModel {

    constructor(params) {
        // Profile
        this.componentName = "customOptionsInlineModel";
        this.context = context;
        //this.id = this.context.util.guid();
        this.id = 'ee02108d-fbfd-4b26-93ed-bacf9d0c6812';
        this.visible = ko.observable(true);

        this.editMode = ko.observable(false);

        this.selectedJob = params.selectedJob;
        this.title = params.title;
        this.data = params.data;
        this.selectedValue = params.selectedValue;
        this.selectedLabel = params.selectedLabel;
        
        this.selected = ko.observable();


        //console.log("customOptionsInlineModel: %o", this);

        this.init();

        /*
        <custom-options-inline params="selectedJob:'', label:'', value:'', data:'', selected:''" ></custom-options-inline>
        */

    }

    init() {

    }

    setSelected() {

        let self = this;
        ko.utils.arrayForEach(this.data(), (item) => {

            //console.log("customOptionsInlineModel:setSelected: %o %o", item, self.selectedValue());

            if(item.id == self.selectedValue())
            {
                self.selected(item);
            }
        });

    }

    clickEditOption() {
        //console.log("customOptionsInlineModel:clickEditOption");
        this.editMode(true);

        if(this.editMode())
        {
            //this.selectedJob.isDirty(true);
            this.setSelected();
        }
        
    }

    toggleEditMode() {
        //console.log("customOptionsInlineModel:toggleEditMode");
        this.editMode(!this.editMode());
        this.selectedLabel(this.selected().label);
        this.selectedValue(this.selected().id);

    }

    updateSelected() {

        try{
            this.selectedLabel(this.selected().label);
            this.selectedValue(this.selected().id);
        }
        catch(err)
        {
            console.log("skipped: selectedLabel and selectedValue");
        }
        
        

        //console.log("customOptionsInlineModel:updateSelected: %o", this);
    }


}

export default { viewModel: customOptionsInlineModel, template: require('!raw-loader!./customOptionsInline.html') };


// WEBPACK FOOTER //
// ./src/components/options/customOptionsInline/customOptionsInline.js